import type { Request } from 'miragejs'
import type { MockServer } from './server.js'

/**
 * Mock server routes for holding place number endpoints.
 * Used for duplicate checking in the company registration form.
 */
export function routes(server: MockServer) {
  /**
   * Check if a holding place number is a duplicate.
   * Returns is_duplicate: true for test number "123456789" to enable testing.
   */
  server.get(
    '/holding_place_numbers/check_duplicate',
    (_schema, request: Request) => {
      const holdingPlaceNumber = request.queryParams.holding_place_number

      // Return duplicate for test number to enable testing the warning flow
      const isDuplicate = holdingPlaceNumber === '123456789'

      return {
        data: {
          type: 'HoldingPlaceNumberDuplicateCheck',
          attributes: {
            is_duplicate: isDuplicate,
            holding_place_number: holdingPlaceNumber,
          },
        },
      }
    },
  )
}
